import { Event, EventListener } from "./Event";

export interface ResizeListener extends EventListener {
  (event:ResizeEvent):void;
}

export class ResizeEvent extends Event  {
}
